import React from "react";
import "./App.css";
import { app, pages } from "@microsoft/teams-js";
import { Button, Input, Text } from "@fluentui/react-components";
import { Toggle } from "@fluentui/react";
import packageJson from "../../package.json";

class TabConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filePaths: [""],
      topicGuid: "",
      teamSiteUrl: "",
    };
  }

  handleInputChange = (index, event) => {
    const newFilePaths = [...this.state.filePaths];
    newFilePaths[index] = event.target.value;
    this.setState({ filePaths: newFilePaths });
  };

  handleAddPath = () => {
    this.setState({ filePaths: [...this.state.filePaths, ""] });
  };

  handleRemovePath = (index) => {
    const newFilePaths = this.state.filePaths.filter((_, i) => i !== index);
    this.setState({ filePaths: newFilePaths });
  };

  componentDidMount() {
    app.initialize().then(async () => {
      const config = await pages.getConfig();
      if (config && config.contentUrl) {
        let contentUrl = config.contentUrl.replace('#', '/');
        const urlParams = new URLSearchParams(new URL(contentUrl).search);
        const encodedUrls = urlParams.get("urls");
        if (encodedUrls) {
          const decodedUrls = decodeURIComponent(encodedUrls).split(",");
          this.setState({ filePaths: decodedUrls });
        }

        const topicGuid = urlParams.get("topic_guid");
        if (topicGuid) {
          this.setState({ topicGuid: decodeURIComponent(topicGuid).trim() });
        }
      }

      const context = await app.getContext();
      if (context?.sharePointSite?.teamSiteUrl) {
        this.setState({ teamSiteUrl: context.sharePointSite.teamSiteUrl });
      }
    });
  }

  render() {
    app.initialize().then(async () => {
      pages.config.registerOnSaveHandler((saveEvent) => {
        const baseUrl = `https://${window.location.hostname}:${window.location.port}`;
        const queryParams = {};

        const filePaths = this.state.filePaths.filter(path => path.trim() !== "");
        if (filePaths.length > 0) {
          const filePathsQueryString = filePaths.map(encodeURIComponent).join(",");
          queryParams.urls = filePathsQueryString;
        }

        const topicGuid = this.state.topicGuid.trim();
        if (topicGuid) {
          queryParams.topic_guid = encodeURIComponent(topicGuid);
        }

        const queryString = Object.keys(queryParams)
          .map(key => `${key}=${queryParams[key]}`)
          .join('&');

        const contentUrl = `${baseUrl}/index.html#/tab${queryString ? '?' + queryString : ''}`;

        pages.config.setConfig({
          suggestedDisplayName: "IFC Viewer",
          entityId: "Test",
          contentUrl: contentUrl,
          websiteUrl: contentUrl,
        }).then(() => {
          saveEvent.notifySuccess();
        });
      });

      pages.config.setValidityState(true);
    });

    return (
      <div style={{ padding: "20px" }}>
        <Text><b>Configure your IFC and BCF files for this tab</b></Text><br></br>
        <Text>To ensure that everyone on your team can easily view the necessary IFC and BCF files, paste the SharePoint links to these files in the fields below. The viewer will load these files by default whenever anyone accesses this tab, making it easy for your team to work with the same files. Having an IFC file is a prerequisite. </Text>
        <a target="_blank" href="https://docs.flinker.app/">Support and installation guide</a>
        <div style={{ marginTop: "20px", marginBottom: "20px" }}>
          {this.state.filePaths.map((path, index) => (
            <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
              <Input
                value={path}
                onChange={(event) => this.handleInputChange(index, event)}
                placeholder="Paste file link"
                style={{ flexGrow: 1, marginRight: "10px" }}
              />
              {this.state.filePaths.length > 1 && (
                <Button onClick={() => this.handleRemovePath(index)} appearance="secondary">
                  Remove
                </Button>
              )}
            </div>
          ))}
        </div>
        <Button onClick={this.handleAddPath} >
          Add another link
        </Button>
        <div style={{ marginTop: "20px" }}>
          <Text><b>Set your default view (optional)</b></Text><br />
          <Text>Enter a BCF topic GUID to load a specific issue by default each time this tab opens.</Text>
          <Input
            value={this.state.topicGuid}
            onChange={(event) => this.setState({ topicGuid: event.target.value })}
            placeholder="Paste a BCF topic GUID"
            style={{ width: "100%", marginTop: "8px" }}
          />
        </div>
        <br />
        <br />
        <Text><b>App Version: </b>{packageJson.version}</Text>
      </div>
    );
  }
}

export default TabConfig;
